import axios from "axios";
import { API_BASE_URL } from "../../config/config.js";
// FastAPI-backend draft client.
//
// All routes live under `/api/v1/data-assets/draft`. The list endpoint is
// scoped to the IM currently selected in the frontend (passed as `?imcode=`),
// mirroring the dataset list endpoint; only `Authorization` is sent.
const BASE = `${API_BASE_URL}/data-assets/draft`;
// The session cookie + X-CSRF-Token are added by src/auth/setupAxios.js.
function authHeaders(_token) {
    return {};
}
/** GET /?imcode=… — list drafts for the given (frontend-selected) IM. */
export async function listDrafts(token, imcode) {
    return axios.get(`${BASE}/`, {
        headers: authHeaders(token),
        params: { imcode },
    });
}
/** GET /{draftId} — fetch a single draft. */
export async function getDraft(token, draftId) {
    return axios.get(`${BASE}/${draftId}`, {
        headers: authHeaders(token),
    });
}
/** POST /?imcode=… — allocate a new draft for the given IM. */
export async function createDraft(token, imcode, body = {}) {
    return axios.post(`${BASE}/?imcode=${encodeURIComponent(imcode)}`, body, {
        headers: {
            ...authHeaders(token),
            "Content-Type": "application/json",
        },
    });
}
/** DELETE /{draftId}?force=… — remove a draft (force needed if locked). */
export async function deleteDraft(token, draftId, opts = {}) {
    const qs = opts.force ? "?force=true" : "";
    return axios.delete(`${BASE}/${draftId}${qs}`, {
        headers: authHeaders(token),
    });
}
/**
 * POST /{draftId}/createDataset — publish a draft.
 *
 * Returns 202 with `{draft_id, dataset_id, published_graph_uri}`. The worker
 * runs the validation + bulk_upload chain asynchronously; callers should
 * poll `getDraft` (or refresh `listDrafts`) to see the lifecycle progress.
 *
 * Throws 423 LOCKED if the draft is already being published — callers
 * should NOT retry automatically; surface the `detail` and keep the row
 * disabled until the lock clears (validation finishes).
 */
export async function publishDraft(token, draftId) {
    return axios.post(`${BASE}/${draftId}/createDataset`, null, {
        headers: authHeaders(token),
    });
}
/**
 * GET /{draftId}/download — stream the draft graph as Turtle.
 *
 * NOTE: this endpoint is not yet implemented on the FastAPI backend (see
 * DRAFTS.md "Not implemented" section). The client method is kept so the
 * UI compiles; calls will 404 until the backend route lands.
 */
export async function downloadDraft(token, draftId) {
    return axios.get(`${BASE}/${draftId}/download`, {
        headers: authHeaders(token),
        responseType: "blob",
    });
}
